import * as hierarchyHelper from "./hierarchyHelper"

export function getEquipmentAccessHierarchyIds(): string[] {
    return hierarchyHelper.getHierarchyItemsAndChildrensIds([null])
}